import styled from 'styled-components';
import { Text } from '../../../../../../../components/Atoms/Text/Text';
import { media } from '../../../../../../../theme/shared/breakpoints';
import { Link } from '../../../../../../components/Link/Link';
import { Pink } from '../../../../../../constants/styles';
export const StyledLink = styled(Link) `
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
export const Button = styled.button `
  border: none;
  background: none;
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  padding: 0;
  color: ${({ theme }) => theme.colorsV2.grayscale.black};
`;
export const ItemWithAvatar = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0; // this is to hide alt text
  gap: 0 5px;
`;
export const IconWrapper = styled.span `
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
export const IconText = styled(Text) `
  text-align: center;
  width: ${({ isAccount }) => (isAccount ? '56px' : '40px')};
  margin-left: -2px;
`;
export const CounterWrapper = styled.div `
  position: absolute;
  top: 6px;
  left: 5px;
  line-height: 17px;
  text-align: center;
  padding: 1px;
`;
export const Counter = styled.div `
  color: ${({ theme }) => theme.colorsV2.font.textWhite};
  font-size: 12px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background-color: ${Pink.x100};
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  padding: 14px 0 10px 0;
  min-width: 36px;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  opacity: ${({ isVisible }) => (isVisible ? 0 : 1)};
  visibility: ${({ isVisible }) => (isVisible ? 'hidden' : 'visible')};
  z-index: 1;

  svg {
    transform: ${(props) => (props.isCart ? 'translateX(3px)' : 'none')};
    margin-bottom: 2px;
  }

  ${media.medium} {
    padding: 14px 4px 10px 4px;
  }
`;
//# sourceMappingURL=AsideMenuItem.styled.js.map